import React from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { profile, stats } from '../data/portfolio';
import { fadeIn } from '../variants';
import SocialLinks from './SocialLinks';

const Banner = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  return (
    <section
      id='home'
      ref={ref}
      className='page-section flex items-center pt-32 md:pt-28'
    >
      <div className='section-shell'>
        <div className='grid min-w-0 items-center gap-14 xl:grid-cols-[1fr_460px]'>
          <motion.div
            variants={fadeIn('right', 0.15)}
            initial={false}
            animate='show'
            className='order-2 min-w-0 text-center xl:order-1 xl:text-left'
          >
            <p className='mb-4 text-lg font-medium text-white/90'>
              {profile.role}
            </p>
            <h1 className='mb-6 text-[36px] font-bold leading-[1.15] text-white sm:text-[54px] md:text-[66px]'>
              Hey, I&apos;m
              <span className='block text-accent'>
                {profile.firstName} {profile.lastName}
              </span>
            </h1>
            <p className='mx-auto mb-8 max-w-[340px] text-base leading-8 text-white/65 sm:max-w-[620px] xl:mx-0'>
              {profile.intro}
            </p>

            <div className='mb-10 flex flex-col items-center justify-center gap-6 sm:flex-row xl:justify-start'>
              {/* Keep for later: <a href='#resume' className='pill-button'>Download CV</a> */}
              <SocialLinks />
            </div>
          </motion.div>

          <motion.div
            variants={fadeIn('left', 0.25)}
            initial={false}
            animate='show'
            className='order-1 flex min-w-0 justify-center xl:order-2 xl:justify-end'
          >
            <div className='photo-frame'>
              <div className='photo-halo' />
              <img
                className='photo-image'
                src={profile.photo}
                alt={`${profile.firstName} ${profile.lastName}`}
              />
              <div className='photo-ring' />
            </div>
          </motion.div>
        </div>

        <motion.div
          variants={fadeIn('up', 0.35)}
          initial={false}
          animate='show'
          className='mt-14 grid grid-cols-3 gap-3 sm:grid-cols-3 sm:gap-5 lg:grid-cols-3 xl:grid-cols-6'
        >
          {stats.map((stat) => (
            <div
              key={stat.label}
              className='flex min-h-[116px] flex-col items-center justify-center gap-2 rounded-[8px] border border-white/10 bg-white/[0.02] px-4 py-5 text-center'
            >
              <span className='text-[42px] font-extrabold leading-none text-white'>
                {stat.label === 'KM traveled' ? (
                  <>
                    <span className='hidden whitespace-nowrap sm:inline'>
                      {inView ? (
                        <CountUp
                          end={stat.value}
                          duration={2.6}
                          separator={stat.separator || ''}
                        />
                      ) : (
                        0
                      )}
                    </span>
                    <span className='flex flex-col items-center sm:hidden'>
                      <span>
                        {inView ? (
                          <CountUp end={stat.value / 1000} duration={2.6} />
                        ) : (
                          0
                        )}
                      </span>
                      <span>000</span>
                    </span>
                  </>
                ) : inView ? (
                  <CountUp
                    end={stat.value}
                    duration={2.6}
                    separator={stat.separator || ''}
                  />
                ) : (
                  0
                )}
              </span>
              <span className='text-sm leading-5 text-white/60'>
                {stat.label}
              </span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Banner;
